var React = require('react');

function HomeArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M80.3272 0.230469L0.616699 79.9409V300.359H89.3382L89.3345 158.956L341.68 411.302H492.699L545.616 358.385V233.62L424.813 354.422L159.34 88.9495L300.745 88.952V0.230469H80.3272Z","fill":"#191919"}));
}

HomeArrow.defaultProps = {"width":"546","height":"412","viewBox":"0 0 546 412","fill":"none"};

module.exports = HomeArrow;

HomeArrow.default = HomeArrow;
